
export namespace observer_utility {
    export class Observer<T, O> {

        private _listener: O[];
        private execute_function: (listener: O, event: T) => void;

        constructor(execute_function: (listener: O, event: T) => void) {
            this._listener = [];
            this.execute_function = execute_function;
        }

        public notify(event: T) {
            this._listener.forEach(el => this.execute_function(el, event))
        }

        public attach(listener: O) {
            this._listener.push(listener);
        }

        public detach(listener: O) {
            this._listener = this._listener.filter(el => el !== listener);
        }

    }
}